import { create } from "jss";
import rtl from "jss-rtl";
import React from "react";
import { StylesProvider } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// Configure JSS
const jss = create();
jss.use(rtl());

const theme = createTheme({
  direction: "rtl",
  components: {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          transform: "scaleX(-1)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        startIcon: {
          transform: "scaleX(-1)",
          marginLeft: 4,
        },
        endIcon: {
          transform: "scaleX(-1)",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          "& .MuiSvgIcon-root": {
            transform: "scaleX(-1)",
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          transform: "scaleX(-1)",
        },
      },
    },
  },
});

function RTL(props) {
  if (!props.isRTL) return <>{props.children}</>;

  return (
    <>
      <StylesProvider jss={jss}>
        <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
      </StylesProvider>
    </>
  );
}

export default RTL;
